import moment from 'moment'
import BookingAmount from './BookingAmount'
import BookingsApi from './Api'

const BookingsIndexMixin = {
  components: {
    BookingAmount,
  },

  methods: {
    orderDateVariant(item) {
      const date = moment(item.ordered_at)

      if (date.isAfter(moment().add(2, 'w'))) {
        return 'alpha-success'
      }

      if (date.isAfter(moment().add(1, 'w'))) {
        return 'alpha-orange'
      }

      if (date.isAfter(moment().add(1, 'd'))) {
        return 'alpha-danger'
      }

      if (date.isAfter()) {
        return 'alpha-purple'
      }

      return 'alpha-grey'
    },
    getOrder(booking) {
      if (booking.order) {
        return booking.order
      }

      return {
        amount: booking.calculated.total,
        currency: booking.calculated.currency,
        currency_label: booking.calculated.currency,
        status: 'pending',
        status_label: this.$t('enums.order_status.pending'),
        payment_method: 'on_invoice',
      }
    },

    block(item) {
      this.activeItem = item
      this.$bvModal.show('block-modal')
    },

    onConfirmBlock({ reason }) {
      this.modalBusy = true
      const api = new BookingsApi()
      api
        .block(this.activeItem.id, reason)
        .then(({ message }) => {
          this.activeItem = null
          this.$toast.success(message)
          this.$bvModal.hide('block-modal')
          this.$refs.table.refresh()
        })
        .catch(() => {})
        .finally(() => {
          this.modalBusy = false
        })
    },

    setCompanyPenalty(item) {
      this.activeItem = item
      this.$bvModal.show('company-penalty-modal')
    },

    onConfirmCompanyPenalty({ amount }) {
      this.modalBusy = true
      const api = new BookingsApi()
      api
        .setCompanyPenaltyAmount(this.activeItem.id, amount)
        .then(({ message }) => {
          this.activeItem = null
          this.$toast.success(message)
          this.$bvModal.hide('company-penalty-modal')
          this.$refs.table.refresh()
        })
        .catch(() => {})
        .finally(() => {
          this.modalBusy = false
        })
    },

    rowActions(item) {
      const actions = []
      if (this.$allows(`bookings.block`) && item.commission_checked === false) {
        if (item.is_blocked) {
          actions.push({
            label: this.$t('bookings.company_penalty'),
            variant: 'warning',
            handler: () => {
              this.setCompanyPenalty(item)
            },
          })
        } else {
          actions.push({
            label: this.$t('bookings.block'),
            variant: 'danger',
            handler: () => {
              this.block(item)
            },
          })
        }
      }
      return actions
    },
  },
}

export default BookingsIndexMixin
